/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_102Inputs */

const vi_carrier_status_102 = /** @type {(inputs: Carrier_Status_102Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lấy hàng thất bại`)
};

/**

* @param {Carrier_Status_102Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_102 = /** @type {((inputs?: Carrier_Status_102Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_102Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_102(inputs)
});